import { createPortal } from "react-dom";

// Matches the PortalShell theme tokens without coupling the modal back to the
// shell module (PortalShell imports this component).
const T = {
  panel: "#112b4d",
  border: "rgba(255,255,255,0.08)",
  text: "#edf4ff",
  muted: "#a8bddc",
  blue: "#44a6ff",
};

export default function IdleWarningModal({ remainingMs, onStay, onSignOut }) {
  const safeRemainingMs = Math.max(0, remainingMs);
  const totalSeconds = Math.ceil(safeRemainingMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, "0");

  return createPortal(
    <div
      role="presentation"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 12001,
        padding: 20,
        background: "rgba(6,16,32,.72)",
        backdropFilter: "blur(3px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'DM Sans',system-ui,sans-serif",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="idle-warning-title"
        aria-describedby="idle-warning-message"
        style={{
          width: "100%",
          maxWidth: 420,
          boxSizing: "border-box",
          padding: 24,
          border: `1px solid ${T.border}`,
          borderRadius: 18,
          background: T.panel,
          boxShadow: "0 24px 60px rgba(0,0,0,.55)",
          color: T.text,
          textAlign: "center",
        }}
      >
        <h2 id="idle-warning-title" style={{ margin: "0 0 8px", fontSize: 22 }}>
          Still there?
        </h2>
        <p id="idle-warning-message" style={{ margin: "0 0 22px", color: T.muted, fontSize: 15 }}>
          You'll be signed out in {minutes}:{seconds}
        </p>
        <button
          type="button"
          onClick={onStay}
          style={{
            width: "100%",
            padding: "11px 16px",
            border: 0,
            borderRadius: 10,
            background: T.blue,
            color: "#061020",
            cursor: "pointer",
            fontFamily: "inherit",
            fontSize: 14,
            fontWeight: 800,
          }}
        >
          Stay signed in
        </button>
        <button
          type="button"
          onClick={onSignOut}
          style={{
            marginTop: 12,
            padding: "6px 10px",
            border: 0,
            background: "transparent",
            color: T.muted,
            cursor: "pointer",
            fontFamily: "inherit",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          Sign out now
        </button>
      </div>
    </div>,
    document.body
  );
}
